import { parseBoolean } from '@chatwoot/utils';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import PlanSelection from './PlanSelection.vue';

const billingRouteGuard = (to, from, next) => {
  const billingEnabled = parseBoolean(window.globalConfig?.BILLING_ENABLED);
  if (billingEnabled) {
    next();
    return;
  }

  next({ name: 'settings_home', params: to.params });
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'BILLING_SETTINGS.TITLE',
        icon: 'credit-card-person',
        showNewButton: false,
      },
      beforeEnter: billingRouteGuard,
      children: [
        {
          path: '',
          name: 'billing_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'plans',
          name: 'billing_settings_plans',
          component: PlanSelection,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
